/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pill_StorefrontInputs */

const en_home_pill_storefront = /** @type {(inputs: Home_Pill_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Own Storefront`)
};

const es_home_pill_storefront = /** @type {(inputs: Home_Pill_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu propia tienda`)
};

const fr_home_pill_storefront = /** @type {(inputs: Home_Pill_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre propre vitrine`)
};

const de_home_pill_storefront = /** @type {(inputs: Home_Pill_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine eigene Storefront`)
};

const ja_home_pill_storefront = /** @type {(inputs: Home_Pill_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなただけのストアフロント`)
};

const zh_home_pill_storefront = /** @type {(inputs: Home_Pill_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的专属店铺`)
};

const ar_home_pill_storefront = /** @type {(inputs: Home_Pill_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واجهة متجرك الخاصة`)
};

const id_home_pill_storefront = /** @type {(inputs: Home_Pill_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etalase Anda Sendiri`)
};

const it_home_pill_storefront = /** @type {(inputs: Home_Pill_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La Tua Vetrina Personale`)
};

const ru_home_pill_storefront = /** @type {(inputs: Home_Pill_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша собственная витрина`)
};

const pt_home_pill_storefront = /** @type {(inputs: Home_Pill_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua Própria Vitrine`)
};

const ko_home_pill_storefront = /** @type {(inputs: Home_Pill_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나만의 스토어프론트`)
};

/**
* | output |
* | --- |
* | "Your Own Storefront" |
*
* @param {Home_Pill_StorefrontInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const home_pill_storefront = /** @type {((inputs?: Home_Pill_StorefrontInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pill_StorefrontInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_pill_storefront(inputs)
	if (locale === "es") return es_home_pill_storefront(inputs)
	if (locale === "fr") return fr_home_pill_storefront(inputs)
	if (locale === "de") return de_home_pill_storefront(inputs)
	if (locale === "ja") return ja_home_pill_storefront(inputs)
	if (locale === "zh") return zh_home_pill_storefront(inputs)
	if (locale === "ar") return ar_home_pill_storefront(inputs)
	if (locale === "id") return id_home_pill_storefront(inputs)
	if (locale === "it") return it_home_pill_storefront(inputs)
	if (locale === "ru") return ru_home_pill_storefront(inputs)
	if (locale === "pt") return pt_home_pill_storefront(inputs)
	return ko_home_pill_storefront(inputs)
});